<script lang="ts" setup>
    const { taxonomy } = defineProps<{
        taxonomy: string
    }>()

    const { data } = await useStatamicTaxonomies().getTaxonomyTerms({
        taxonomy,
    })
</script>

<template>
    <ul>
        <li v-for="term in data" class="pb-1 lg:pb-0">
            <NuxtLink :to="term.url" class="transition hover:text-medium">
                {{ term.title }}
            </NuxtLink>
        </li>
    </ul>
</template>
